import { useMutation } from '@tanstack/react-query'

import { deleteSteeringRange } from '@/features/resource/endpoints/resources'

export function useDeleteSteeringRangeMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (rangeId: string) => deleteSteeringRange(resourceId, rangeId),
  })

  return {
    deleteSteeringRange: mutateAsync,
    ...mutationResult,
  }
}
